import { QueryResults } from '@/features/QueryResults';
import { EventFilterView } from '@/features/EventFilterView';
import { SidePanel } from '@/components/SidePanel';
import { EventFilter, EventSort } from '@/features/BrowseBar';
import type { EventsBrowseBarConfig } from '@/features/BrowseBar';
import { BackButton } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { hasRouterHistory } from '@/stores/navigation-history.store';

const QUERY_RESULTS_CONFIG: EventsBrowseBarConfig = {
    filters: [
        EventFilter.CONFIDENCE,
        EventFilter.DATE_RANGE,
        EventFilter.SOURCE,
        EventFilter.OBJECT_TYPE,
    ],
    sorts: [EventSort.DATE, EventSort.CONFIDENCE],
    requireSource: true,
};

export default function QueryResultsPage() {
    useDocumentTitle('explore');

    const showBackButton = hasRouterHistory();

    return (
        <div className="relative h-full min-h-0">
            <SidePanel side="left">
                <EventFilterView config={QUERY_RESULTS_CONFIG} />
            </SidePanel>
            {showBackButton && <BackButton variant="floating" />}
            <div className="h-full flex flex-col items-center px-4 panels:px-8">
                <div className="w-full flex-1 min-h-0">
                    <QueryResults />
                </div>
            </div>
        </div>
    );
}
